export default "__VITE_ASSET__bff509bb__"